// extracted by mini-css-extract-plugin
export default {"zoomModal":"c3-z","image":"d3-z","button":"e3-z","isOverlayShown":"f3-z"};